import t from "@ext/localization/locale/translate";
import { AgentErrorType } from "../../core/agentError";

export const getLocalizedAgentErrorTypeMessage = (errorType: AgentErrorType, isGesCloud: boolean): string => {
	switch (errorType) {
		case AgentErrorType.Unauthorized:
			return t("agent.error-type.unauthorized");
		case AgentErrorType.Forbidden:
			return t("agent.error-type.forbidden");
		case AgentErrorType.PaymentRequired:
			return t("agent.error-type.payment_required");
		case AgentErrorType.BalanceExhausted:
			return isGesCloud
				? t("agent.error-type.balance-exhausted.enterprise-cloud")
				: t("agent.error-type.balance-exhausted.enterprise");
		case AgentErrorType.MaxStepsExceeded:
			return t("agent.error-type.max_steps_exceeded");
		case AgentErrorType.NetworkError:
			return t("agent.error-type.network_error");
		case AgentErrorType.EmptyResponse:
			return t("agent.error-type.empty_response");
		case AgentErrorType.Unexpected:
			return t("agent.error-type.unexpected");
		default:
			return t("agent.error-type.unexpected");
	}
};
